import {
  call, put, take,
} from 'redux-saga/effects';
import Cookies from 'js-cookie';
import jwt from 'jsonwebtoken';

import * as errorActions from '../../errors/actions';
import firebase from '../../utils/firebase';

import * as userActions from '../user/actions';
import * as userServices from '../user/services';
import * as actions from './actions';
import * as services from './services';
import { TokenExpiredError, AuthenticationFailedError } from './errors';

function* fetchUser() {
  let response = {};

  try {
    response = yield call(userServices.fetchUser);
  } catch (e) {
    if (e.response.status === 401) {
      response = yield call(userServices.fetchLegacyUser);
    }
  }

  yield put(userActions.fetchUserSuccess({ info: response.data }));

  return response.data;
}

function* signInFirebase(accessToken) {
  const response = yield call(services.createFirebaseToken, accessToken);
  const customToken = response.data.custom_token;

  yield call(firebase.auth.signInWithCustomToken, customToken);
}

export function* setAuth() {
  while (true) {
    try {
      const { payload: { accessToken } } = yield take(actions.SET_AUTH_REQUEST);

      if (accessToken) {
        const tokenExpiredAt = jwt.decode(accessToken).exp * 1000;
        const isNotExpired = tokenExpiredAt > Date.now();

        if (!isNotExpired) {
          yield put(actions.setAuthFailure({
            error: new TokenExpiredError(),
          }));
          break;
        }
        Cookies.set('access_token', accessToken, { expires: new Date(tokenExpiredAt) });

        yield call(fetchUser);

        yield call(signInFirebase, accessToken);

        yield put(actions.setAuthSuccess({ accessToken }));
      } else {
        yield put(actions.setAuthFailure({
          error: new AuthenticationFailedError(),
        }));
      }
    } catch (error) {
      yield put(actions.setAuthFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}
